import { NgModule } from "@angular/core";
import { ConnectionServices } from "./authentication/connection/connection.service";
import { ConfigService } from "./authentication/connection/config.service";
import { IdentityService } from "./authentication/identity.service";
import { MultiRegionService } from "./multiregion/multiregion.service";
import { SessionService } from "./session/session.service";
import { StorageService } from "./storage/storage.service";
import { NavigationService } from "./utilities/navigation.service";
import { AuthenticationService } from "./authentication/authentication.service";
import { JwtService } from "./utilities/jwt.service";
import { CarrierService } from "./carrier/carrier.service";
import { AdminService } from "./admin/admin.service";
import { PaymentMethodLabelService } from "./utilities/payment-method-labels.service";
import { GooglePlacesService } from "./google-places.service";
import { GeocodingService } from "./geocoding.service";
import { FileService } from "./file.service";
import { LocalizationService } from "./localization/localization.service";
import { TravelService } from "./travel-fare/command/travel.service";
import { FormControlService } from "./utilities/form-control.service";
import { PassengerService } from "./passenger/passenger.service";
import { ClientsService } from "./client/clients.service";
import { AreasService } from "./areas/areas.services";
import { VehicleTypeService } from "./vehicle/vehicleType.services";
import { MercadoPagoService } from "./payment-processors/mercado-pago.service";
import { TimeZoneService } from "./time-zone/time-zone.service";
import { DateService } from "./utilities/date.service";
import { VehicleService } from "./vehicle/vehicle.services";
import { TravelFareService } from "./travel-fare/travel-fare.service";
import { GeneralParametersService } from "./general-parameters/general-parameters.service";
import { ContractorService } from "./contractor/contractor.service";
import { ProfileAccessService } from "./profiles/profile-access.service";
import { ProgressBarService } from "./components/progress-bar/progress-bar.service";
import { PushNotificationService } from "./utilities/push-notification.service";
import { CheckingAccountsService } from "./checking-accounts/checking-accounts.service";
import { DriverService } from "./driver/driver.service";
import { CalendarService } from "./utilities/calendar.service";
import { OwnerService } from "./owner/owner.service";
import { UsersListService } from "./users-list/users-list.service";
import { DocumentationService } from "./document/documentation.service";
import { ComboService } from "./utilities/combo.service";
import { KeyCodeService } from "./utilities/key-code.service";
import { MaskService } from "./utilities/mash.service";
import { VendorService } from "./carrier/vendor.service";
import { ODNService } from "./carrier/odn.service";
import { FlightsService } from "./carrier/flights.service";
import { IntegrationService } from "./carrier/integration.service";

@NgModule({
  providers: [
    CalendarService,
    ComboService,
    KeyCodeService,
    ConnectionServices,
    ConfigService,
    IdentityService,
    MultiRegionService,
    SessionService,
    StorageService,
    NavigationService,
    AuthenticationService,
    DriverService,
    OwnerService,
    UsersListService,
    DocumentationService,
    JwtService,
    CarrierService,
    AdminService,
    PaymentMethodLabelService,
    GooglePlacesService,
    GeocodingService,
    FileService,
    LocalizationService,
    TravelService,
    FormControlService,
    PassengerService,
    ClientsService,
    AreasService,
    VehicleTypeService,
    MercadoPagoService,
    TimeZoneService,
    DateService,
    VehicleService,
    TravelFareService,
    GeneralParametersService,
    ContractorService,
    ProfileAccessService,
    ProgressBarService,
    PushNotificationService,
    CheckingAccountsService,
    KeyCodeService,
    ComboService
    ,
    MaskService,
    VendorService,
    ODNService,
    FlightsService,
    IntegrationService
  ],
})
export class ServicesModule {
  constructor() { }
}
